import { createContext } from 'react';

interface AccountLogoContextProps {
  logoURI: string | null;
  handleSetLogoURI: (uri: string | null) => void;
}

export const LogoContext = createContext<Partial<AccountLogoContextProps>>({});
